export default "__VITE_ASSET__BkUar_qS__"